import React from 'react';
import PropTypes from 'prop-types';

import { StyledTextField } from '../../../../../components/Inputs';
import SectionCard from '../../components/SectionCard';
import texts from '../../texts.json';

const CampaignNameSection = ({ value, autoGeneratedName, onChange }) => (
  <SectionCard
    title={texts.sections.campaignName.title}
    subtitle={texts.sections.campaignName.subtitle}
  >
    <StyledTextField
      fullWidth
      value={value}
      placeholder={autoGeneratedName}
      onChange={(event) => onChange(event.target.value)}
      inputProps={{ 'aria-label': texts.sections.campaignName.title }}
    />
  </SectionCard>
);

CampaignNameSection.propTypes = {
  value: PropTypes.string.isRequired,
  autoGeneratedName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CampaignNameSection;
